module.exports = __webpack_public_path__ + "static/img/sign.a45722dd.png";